import type { Skill } from '@atlassian/rovo-platform-ui-components/skills/types';

import type { RovoSkillsInsertMenuConfig } from './types';

/**
 * Filter skills based on the insert menu configuration.
 *
 * - If `showAllSkills` is true, returns all skills (dev/testing mode).
 * - Otherwise, filters to only skills whose slug is in `allowedSkills`.
 * - If `allowedSkills` is empty or undefined, returns an empty array.
 * - The returned order matches the order of `allowedSkills`.
 */
export function filterSkills(
	skills: Skill[],
	config: Pick<RovoSkillsInsertMenuConfig, 'allowedSkills' | 'showAllSkills'>,
): Skill[] {
	if (config.showAllSkills) {
		return skills;
	}

	const allowedSlugs = config.allowedSkills ?? [];
	if (allowedSlugs.length === 0) {
		return [];
	}

	const skillsBySlug = new Map(skills.map((skill) => [skill.slug, skill]));

	return allowedSlugs
		.map((slug) => skillsBySlug.get(slug))
		.filter((skill): skill is Skill => skill !== undefined);
}
